import type {ContentBlocksFragment} from '@/modules/foundation/sanity/content-blocks/query';

import {FAQ_IN_CARD_FRAGMENT} from '../../../sanity/query';

import type {BLOCK_TYPE_FAQ_LIST_AREA} from './constants';

export const FAQ_LIST_AREA_FRAGMENT = `//groq
	...,
	"faqs": *[_type == "faq" && references(^.area._ref)] | order(orderRank) {
		${FAQ_IN_CARD_FRAGMENT},
	}
`;

export type FaqListAreaFragment = Extract<
	ContentBlocksFragment[number],
	{_type: typeof BLOCK_TYPE_FAQ_LIST_AREA}
>;
